import React, { useState } from "react";
import styles from "./index.module.scss";
import ButtonRade from "../../components/RadeButtons";
import AttachFile from "../../components/AttachFile/AttachFile";
import { radexAuth } from "../../firebase";

const PushNotifications = () => {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const handleOnChangeTitle = (e) => {
    setTitle(e.target.value);
  };
  const handleOnChangeContent = (e) => {
    setMessage(e.target.value);
  };
  const handleOnClickPushButton = async () => {
    if (!title.trim() || !message.trim()) {
      setError("Title and Content cannot be empty");
      return;
    }
    try {
      const idToken = await radexAuth.currentUser.getIdToken(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify({
          title: title,
          message: message,
        }),
      };
      const response = await fetch(
        process.env.REACT_APP_MANGO_SERVER_URI +
          "/admin-push-notification/general",
        requestOptions
      );
      if (!response.ok) {
        setError("Failed to send notification");
      }
      setTitle("");
      setMessage("");
    } catch (error) {
      setError("Error sending notification:", error);
    }
  };

  return (
    <div className={styles.manageNotificationsMainContainer}>
      <div className={styles.titleInputContainer}>
        <input
          type="text"
          placeholder="Enter the notification title"
          onChange={handleOnChangeTitle}
          value={title}
          className={styles.inpuContainer}
        ></input>
      </div>
      <div className={styles.contentInputContainer}>
        <input
          type="text"
          placeholder="Enter the notification message"
          onChange={handleOnChangeContent}
          value={message}
          className={styles.inpuContainer}
        ></input>
      </div>
      <AttachFile />
      <ButtonRade
        customStyling={styles.pushButton}
        onClick={handleOnClickPushButton}
      >
        Push General Notifications
      </ButtonRade>
      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
};

export default PushNotifications;
